import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import {IStore} from 'redux/interface';

import {maxServiceCards} from 'utils/constants/constants';

import Loader from 'components/loader';
import {ICmService, ICmServicePage} from '../../redux/cm-service/interfaces';
import CmServiceCard from '../cm-service-card';

import './styles.scss';
import {Pages} from '../../utils/constants/routeConstants';

type Props = {
  cards: ICmService[];
  showLoader?: boolean;
  onLoadMore?: (count: number) => void;
  onClickCard: (srvId: number) => void;
  disabledButtons?: boolean;
  checkedCards?: number[];
  page?: ICmServicePage;
}

export const CmCardSection = ({
  showLoader = false,
  cards,
  onLoadMore,
  onClickCard,
  disabledButtons = false,
  checkedCards = [],
  page
}: Props): JSX.Element => {
  const {
    userProfile, settings
  } = useSelector((state: IStore) => state.auth);
  const [countCards, setCountCards] = useState(onLoadMore ? maxServiceCards : cards.length);
  const [totalElements, setTotalElements] = useState(0);
  const [cardsList, setCardsList] = useState<ICmService[]>(cards);
  const [referralsRole, setReferralsRole] = useState<string | null>(null);
  const [showReferralsButton, setShowReferralsButton] = useState<boolean>(false);

  useEffect(() => {
    if (page) {
      setTotalElements(page.totalElements);
    }
  }, [page]);

  useEffect(() => {
    setCardsList(cards);
    setCountCards(cards.length);
  }, [cards]);

  useEffect(() => {
    const sitePage = settings?.pages.find((p) => p.name === Pages.Referrals);

    if (sitePage) {
      setShowReferralsButton(true);
      if (sitePage.role) {
        setReferralsRole(sitePage.role);
      }
    }
  }, [settings]);

  function LoadMore() {
    if (onLoadMore) {
      onLoadMore(countCards / maxServiceCards);
    }
    setCountCards(countCards + maxServiceCards);
  }

  function handleClickCard(id: number) {
    return () => {
      onClickCard(id);
    };
  }

  const buttonLoadMore = totalElements && totalElements > maxServiceCards && totalElements > countCards && onLoadMore
    ? (<button onClick={LoadMore} className="cm-card-section__button-load">
      <FormattedMessage id={'gritx.cmresource.sectionCards.load'} defaultMessage={'Load more cards'}/>
    </button>)
    : null;

  return <section className="cm-card-section">
    <ul className="cm-card-section__list">
      {
        cardsList.map((card, i) => {
          return i < countCards
            ? <li key={card.srvId} className="cm-card-section__item">
              <CmServiceCard
                card={card}
                referralsRole={showReferralsButton && !!referralsRole && userProfile?.roles.includes(referralsRole)}
                checked={checkedCards.includes(card.srvId)}
                disabledButtons={disabledButtons}
                onClick={handleClickCard(card.srvId)}/>
            </li> : null;
        })
      }
    </ul>
    <div className="card-section__footer">
      {showLoader ? <Loader/> : buttonLoadMore}
    </div>
  </section>;
};
